import { render, staticRenderFns } from "./MySessionsMain.vue?vue&type=template&id=b98cc204&scoped=true"
import script from "./MySessionsMain.vue?vue&type=script&lang=js"
export * from "./MySessionsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98cc204",
  null
  
)

export default component.exports